export const instructorBookingEndpoints = {
    buyer: {
        list: {
            api: '/api/iris/instrbooking/buyer/list',
            method: 'GET',
            parameter: false
        },
        instructorProductList: {
            api: '/api/iris/instrbooking/instructorproduct/list',
            method: 'GET',
            parameter: false
        },
        tttProductList: {
            api: '/api/iris/instrbooking/tttproduct/list',
            method: 'GET',
            parameter: false
        },
        instructorProductLanguages: {
            api: '/api/iris/instrbooking/instructorproduct/languages',
            method: 'GET',
            parameter: false
        },
        tttDeliveryFormats: {
            api: '/api/iris/instructorBooking/deliveryFormats',
            method: 'GET',
            parameter: false
        },
        instructorProductByProductVariantSku: {
            api: '/api/iris/instrbooking/instructorproduct/productByProductVariantSku',
            method: 'GET',
            parameter: true
        },
        accountCurrency: {
            api: '/api/iris/instrbooking/buyer/currency',
            method: 'GET',
            parameter: false
        },
        bookingWithdraw: {
            api: '/api/iris/instrbooking/buyer/bookingwithdraw',
            method: 'POST',
            parameter: false
        },
        addBooking: {
            api: '/api/iris/instrbooking/buyer/add',
            method: 'POST',
            parameter: false
        },
        rejectQuotes: {
            api: '/api/iris/instrbooking/buyer/reject',
            method: 'POST',
            parameter: false
        },
        sendQuote: {
            api: '/api/iris/instrbooking/buyer/send',
            method: 'POST',
            parameter: false
        },
        cancellationRates: {
            api: '/api/iris/instrbooking/buyer/cancellationrates',
            method: 'GET',
            parameter: false
        },
        cancelBooking: {
            api: '/api/iris/instrbooking/buyer/cancelbooking',
            method: 'POST',
            parameter: false
        },
        confirmBookingCancellation: {
            api: '/api/iris/instrbooking/buyer/confirmbookingcancellation',
            method: 'POST',
            parameter: false
        },
        confirmTeSettlement: {
            api: '/api/iris/instrbooking/seller/evaluateexpenseitemsdeliveredcourse',
            method: 'POST',
            parameter: false
        }
    },
    seller: {
        list: {
            api: '/api/iris/instrbooking/seller/list',
            method: 'GET',
            parameter: false
        },
        instructorProfile: {
            add: {
                api: '/api/iris/instrbooking/seller/instructorprofile/add',
                method: 'POST',
                parameter: false
            },
            delete: {
                api: '/api/iris/instrbooking/seller/instructorprofile/delete',
                method: 'POST',
                parameter: false
            }
        },
        instructorQuoteSubmit: {
            api: '/api/iris/instrbooking/sellerquote/submittobuyer',
            method: 'POST',
            parameter: false
        },
        expenseItemsCancellation: {
            post: {
                api: '/api/iris/instrbooking/seller/expenseitempost',
                method: 'POST',
                parameter: false
            },
            sendToBuyer: {
                api: '/api/iris/instrbooking/seller/sendexpensetobuyer',
                method: 'POST',
                parameter: false
            }
        },
        expenseItemsDeliveredCourse: {
            post: {
                api: '/api/iris/instrbooking/seller/expenseteitempost',
                method: 'POST',
                parameter: false
            },
            sendToBuyer: {
                api: '/api/iris/instrbooking/seller/sendexpensetobuyerte',
                method: 'POST',
                parameter: false
            }
        },
        markBookingAsCompleted: {
            api: '/api/iris/instrbooking/seller/markInstructorbookingascompleted',
            method: 'POST',
            parameter: false
        },
        notes: {
            add: {
                api: '/api/iris/instrbooking/seller/notes/add',
                method: 'POST',
                parameter: false
            },
            delete: {
                api: '/api/iris/instrbooking/seller/notes/delete',
                method: 'POST',
                parameter: false
            }
        }

    },
    booking: {
        details: {
            api: '/api/iris/instrbooking/booking/details',
            method: 'GET',
            parameter: true
        }
    },
    dictionary: {
        travelExpensesTypes: {
            api: '/api/iris/configuration/dictionary/travelExpenses-billing-type',
            method: 'GET',
            parameter: false
        },
        rejectionTypes: {
            api: '/api/iris/configuration/dictionary/quote-rejection-type',
            method: 'GET',
            parameter: false
        },
        timeZones: {
            api: '/api/timezones',
            method: 'GET',
            parameter: false
        },
        bookingType: {
            api: '/api/iris/dictionary/booking-types',
            method: 'GET',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/instr-booking.endpoints.ts